import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const fetchClientDetail = async function (id) {
  try {
    const res = await axios.get(urls.clientDetail + `/${id}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * network call for create and edit client company detail
 * @param {boolean} isEdit is sending an edit or not
 * @param {object} form form to send
 */
const clientCompanyDetail = async function (isEdit, form) {
  try {
    const { name, ...otherProps } = form
    let data = {
      ...otherProps,
      clientName: name
    }
    if (form.clientId) data.clientId = form.clientId
    let res
    // console.log('TCL: data clientCompanyDetail', data)
    if (isEdit) {
      res = await axios.put(urls.clientCompanyCreateEdit, data)
    } else {
      res = await axios.post(urls.clientCompanyCreateEdit, data)
    }
    return res.data
  } catch (error) {
    console.log('TCL: catch -> error', error)
    return Promise.reject(error)
  }
}

/**
 * network call for create and edit client contract detail
 * @param {boolean} isEdit is sending an edit or not
 * @param {Object} form form to send
 */
const clientContractDetail = async function (isEdit, form) {
  console.log('TCL: form', form)
  try {
    let {
      averageValuePerShipment: averageValueShipment,
      bankAccountName,
      bankAccountNo,
      bankName,
      clientId,
      contractPeriodEnd: endDate,
      contractPeriodStart: startDate,
      insurance,
      isAuditedByKap: isAuditedByKAP,
      operationalPic: operationalPIC,
      operationalPicMsisdn: operationalPICNo,
      paymentMethod,
      paymentPic: paymentPIC,
      paymentPicMsisdn: paymentPICNo,
      shareholder,
      termOfPayment,
      totalAsset,
      totalSales,
      typeOfServicesUsed: typeOfServiceUsed,
      ventureCapital,
      contractNo,
      isMultiShipper,
    } = form
    let data = {
      clientId,
      startDate,
      endDate,
      termOfPayment,
      paymentMethod,
      paymentPIC,
      paymentPICNo,
      operationalPIC,
      operationalPICNo,
      insurance,
      isAuditedByKAP,
      averageValueShipment,
      totalAsset,
      ventureCapital,
      totalSales,
      shareholder,
      bankName,
      bankAccountName,
      bankAccountNo,
      typeOfServiceUsed,
      contractNo,
      isMultiShipper,
    }
    // console.log('TCL: clientContractDetail data', data)
    let res
    if (isEdit) {
      res = await axios.put(urls.clientContractCreateEdit, data)
    } else {
      res = await axios.post(urls.clientContractCreateEdit, data)
    }
    // console.log('TCL: res', res)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch client's user
 * @param {Number} clientId client Id
 * @param {Array.<String>} roles roles to display
 */
const fetchClientAdmins = async function (clientId, roles = []) {
  try {
    let data = {
      page: 0,
      size: 3,
      clientId,
      role: roles
    }
    let res = await axios.get(urls.userList + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

const postClientAdmin = async function (data) {
  console.log('TCL: data', data)
  try {
    let res = await axios.post(urls.userBatchCreate, data)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * Fetch client's users
 * @param {Number} clientId client Id
 * @param {Object} filters filter
 *  @param {Number} filters.page filter
 *  @param {String} filters.sort sort format: field;ASC|DESC
 *  @param {Array.<String>} filters.roles filter
 */
const fetchClientUsers = async function (clientId, filters) {
  try {
    let data = {
      page: filters.page - 1,
      size: 10,
      clientId,
      role: filters.roles
    }
    if (filters.sort) data.sort = filters.sort
    let res = await axios.get(urls.userList + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    console.log('TCL: }catch -> error', error)
    return Promise.reject(error)
  }
}

/**
 *  fetch client list by filter
 * @param {Object} filters filter object
 * @param {number} filters.page pagination page number start from 0
 * @param {number} filters.size pagination entry size
 * @param {!string} filters.name client name like
 * @param {string} filters.type client type
 * @param {string} filters.sort sort format: field;ASC|DESC
 */
const fetchClients = async function (filters) {
  try {
    let data = querystring.stringify(filters)
    let res = await axios.get(urls.clientList + '?' + data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * set the customers contract status
 * @param {number} id clientId
 * @param {string} status status to set into the customer
 */
const setClientStatus = async function (id, status) {
  try {
    let res = await axios.post(`${urls.clientStatus}/${id}/${status}`)
    console.log('TCL: setClientStatus -> res', res)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch client's contract route and transport
 * @param {Number} id clientId
 * @param {String} clientType client type 'SHIPPER' or 'TRANSPORTER'
 */
const fetchClientContractRouteAndTransport = async function (id, clientType) {
  try {
    let res = await axios.get(urls.contractRouteAndTransport + `/${id}/${clientType}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * post or edit client contract rpute and transport
 * @param {Boolean} isEdit whether is editing an existing contract
 * @param {Number} id clientId
 * @param {Object} form submitted form
 * @param {String} clientType client type 'SHIPPER' or 'TRANSPORTER'
 */
const setClientContractRouteAndTransport = async function (isEdit, id, form, clientType) {
  console.log('TCL: setClientContractRouteAndTransport -> isEdit', isEdit, id, form)
  try {
    let res
    if (isEdit) {
      let data = {
        delete: form.delete,
        new: form.new
      }
      res = await axios.put(urls.contractRouteAndTransport + `/${id}/${clientType}`, data)
    } else {
      let data = {
        origins: form.originLocations,
        destinations: form.destinationLocations,
        transportTypes: form.vehicles
      }
      res = await axios.post(urls.contractRouteAndTransport + `/${id}/${clientType}`, data)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch client contract price list
 * @param {Number} id clientId
 * @param {String} clientType client type 'SHIPPER' or 'TRANSPORTER'
 */
const fetchClientContractPriceList = async function (id, clientType) {
  try {
    let res = await axios.get(urls.contractPriceList + `/${id}/${clientType}`)
    console.log('fafan', urls.contractPriceList + `/${id}/${clientType}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * set client price list
 * @param {Number} id clientId
 * @param {Object} data submitted pricelist
 * @param {String} clientType client type 'SHIPPER' or 'TRANSPORTER'
 */
const setClientPriceList = async function (id, data, clientType) {
  console.log('TCL: id, data, clientType', id, data, clientType)
  try {
    let res = await axios.post(urls.contractPriceList + `/${id}/${clientType}`, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transport type list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} name search text
 *  @param {String} sort sorting format: field;ASC|DESC
 */
const fetchTransportTypes = async function ({ page, size, name, sort }) {
  console.log('TCL: { page, size, name }', { page, size, name, sort })
  try {
    let data = {
      page,
      size,
      name,
      sort
    }
    const res = await axios.get(urls.vehicleList + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch the detail of a transport type
 * @param {Number} id Transport Type id
 */
const fetchTransportTypeDetail = async function (id) {
  try {
    const res = await axios.get(urls.transportTypeDetail + '/' + id)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create and edit transport Type
 * @param {Object} form submitted form
 * @param {String} form.name transportType name
 * @param {Number} form.length transportType length
 * @param {Number} form.width transportType width
 * @param {Number} form.height transportType height
 * @param {Number} form.volume transportType volume
 * @param {Number} form.maxWeight transportType maxWeight
 * @param {String} form.imageUrl transportType imageUrl
 * @param {Number} [transportTypeId] Transport Type Id
 */
const createEditTransportType = async function (form, transportTypeId) {
  console.log('TCL: form, transportTypeId', form, transportTypeId)
  try {
    let res
    if (!transportTypeId) {
      res = await axios.post(urls.transportTypeDetail, form)
    } else {
      res = await axios.put(urls.transportTypeDetail + '/' + transportTypeId, form)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch selection list
 * @param {Object} filters selection list filter
 *  @param {Number} filters.page list pagination page number
 *  @param {Number} filters.size list pagination entry count
 *  @param {String} [filters.value] selection info text value for search
 *  @param {String} filters.type selection info list type
 */
const fetchSelectionsInfos = async function ({ page, size, value, type, sort }) {
  try {
    const filter = {
      page, size, value, type, sort
    }
    console.log('TCL: filter', filter)
    const res = await axios.get(urls.selectionInfoFilter + '?' + querystring.stringify(filter))
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * edit or create new entry for a selection list
 * @param {Object} form Selection Item form
 *  @param {String} form.value Selection item value text
 *  @param {String} form.type Selection list type
 *  @param {Number} [form.id] Selection item id for updating
 *  @param {Boolean} [form.confirmation] if value needs to be confirmed
 */
const createEditSelectionInfo = async function ({ value, type, id, confirmation }) {
  try {
    let res
    const data = {
      value,
      type,
      confirmation,
    }
    console.log('TCL: data', data)
    if (id) {
      res = await axios.put((urls.selectionInfo + '/' + id), data)
    } else {
      res = await axios.post(urls.selectionInfo, data)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchClientContractCustomPriceList = async function (id, clientType, originId, destinationId) {
  try {
    let filter = {
      originId: originId,
      destinationId: destinationId
    }
    let res = await axios.get(urls.contractPriceList + `/${id}/${clientType}` + '?' + querystring.stringify(filter))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchClientDetail,
  clientCompanyDetail,
  clientContractDetail,
  fetchClientAdmins,
  postClientAdmin,
  fetchClients,
  setClientStatus,
  fetchClientContractRouteAndTransport,
  setClientContractRouteAndTransport,
  fetchClientContractPriceList,
  setClientPriceList,
  fetchTransportTypes,
  fetchTransportTypeDetail,
  createEditTransportType,
  fetchSelectionsInfos,
  createEditSelectionInfo,
  fetchClientUsers,
  fetchClientContractCustomPriceList
}
